import { useEffect } from 'react'

import { Config } from '@flowwai-frontend/shared/constants'

import { USER_SNAP_ID } from '../constants/UserSnapConstants'

import { useReportBug } from './useReportBug'

declare global {
   interface Window {
      Usersnap: any
      onUsersnapLoad: any
      Userback: any
   }
}

type BugReportingService = 'USER_SNAP' | 'USER_BACK'

export const useUsersnap = () => {
   const reportBug = useReportBug()

   const bugReportingService = Config.BUG_REPORTING_SERVICE as BugReportingService

   useEffect(() => {
      const script = document.createElement('script')

      switch (bugReportingService) {
         case 'USER_BACK': {
            const userbackAccessToken = Config.USER_BACK_ACCESS_TOKEN
            if (!userbackAccessToken) break

            //NOTE: Added try catch to prevent app crashes due to userback script issues.
            try {
               if (window.Userback?.isLoaded?.()) {
                  window.Userback.init(userbackAccessToken, {
                     custom_data: reportBug?.customData
                  })
                  return
               }

               script.src = 'https://static.userback.io/widget/v1.js'
               script.async = true

               script.onload = () => {
                  window.Userback.init(userbackAccessToken, {
                     custom_data: reportBug?.customData
                  })
               }

               if (!window.Userback) {
                  document.body.appendChild(script)
               } else {
                  window.Userback.init(userbackAccessToken, {
                     custom_data: reportBug?.customData
                  })
               }
            } catch (e) {
               console.warn(e)
            }
            break
         }
         //NOTE:Not using usersnap
         case 'USER_SNAP':
         default: {
            // script.src = `https://widget.usersnap.com/global/load/${USER_SNAP_ID}?onload=onUsersnapLoad`

            // if (!window.Usersnap) {
            //    window.onUsersnapLoad = function (api: any) {
            //       api.init({
            //          custom: reportBug?.customData
            //       })
            //       window.Usersnap = api
            //    }
            //    script.async = true

            //    document.body.appendChild(script)
            // } else {
            //    window.Usersnap.init({
            //       custom: reportBug?.customData
            //    })
            // }
            break
         }
      }

      return () => {
         try {
            document.body.removeChild(script)
         } catch (e) {
            console.error(e)
         }
      }
   }, [reportBug?.customData])

   useEffect(() => {
      if (window.Userback?.isLoaded?.()) {
         for (let i = document.styleSheets.length - 1; i >= 0; i--) {
            const sheet = document.styleSheets[i]

            if (sheet.href !== 'https://static.userback.io/widget/v1.css')
               continue

            try {
               for (let j = sheet.cssRules.length - 1; j >= 0; j--) {
                  if (sheet.cssRules[j].type === CSSRule.FONT_FACE_RULE) {
                     sheet.deleteRule(j)
                  }
               }
            } catch (e) {
               console.warn(e)
            }
         }
      }
   }, [window.Userback?.isLoaded?.()])

   return {}
}
